import { useLocation, useSearchParams } from 'react-router-dom';

export const useCreatePatient = () => {
  const [params, setParams] = useSearchParams();
  const paramIsOpenString = params.get('createPatient');

  const location = useLocation();

  const isModalOpen = paramIsOpenString ? JSON.parse(paramIsOpenString) : false;

  const openModalHandler = () => {
    setParams({ createPatient: 'true' });
  };

  const closeModalHandler = () => {
    setParams({});
  };

  const setUrlParamsData = (data: { id: string; firstname: string; lastname: string; oht: string; date: string }) => {
    const objParams = {
      createPatient: true,
      id: data.id,
      firstname: data.firstname,
      lastname: data.lastname,
      oht: data.oht,
      date: data.date,
    };

    window.history.replaceState(
      null,
      '',
      location.pathname +
        '?' +
        Object.entries(objParams)
          .filter(([_, value]) => Boolean(value))
          .map(([key, value]) => `${key}=${value}`)
          .join('&'),
    );
  };

  const paramsData = {
    id: params.get('id'),
    firstname: params.get('firstname'),
    lastname: params.get('lastname'),
    oht: params.get('oht'),
    date: params.get('date'),
  };

  return {
    isOpen: isModalOpen,
    openModalHandler,
    closeModalHandler,
    setUrlParamsData,
    paramsData,
  };
};
